'use client';

import { FC, PropsWithChildren } from 'react';
import { GlossaryProvider } from './_context/GlossaryContext';
import GlossaryRouterProvider from './_context/GlossaryRouterProvider';

const GlossaryLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <GlossaryProvider>
      <GlossaryRouterProvider>{children}</GlossaryRouterProvider>
    </GlossaryProvider>
  );
};

export default GlossaryLayout;
